// extracted by mini-css-extract-plugin
export default {"date":"AdvertCard_date__-ZyCt","title":"AdvertCard_title__z20PH","titleTypeFullText":"AdvertCard_titleTypeFullText__cytow","text":"AdvertCard_text__bPOQm"};